import { t } from '../../i18n';

export type Role =
  | 'miembro'
  | 'responsable_entidad'
  | 'responsable_ayuntamiento'
  | 'coordinador'
  | 'admin';

export enum RoleEnum {
  'miembro' = 'Miembro',
  'responsable_entidad' = 'Responsable entidad',
  'responsable_ayuntamiento' = 'Responsable ayuntamiento',
  'coordinador' = 'Coordinador',
  'admin' = 'Administrador',
}
